
import { Component, Vue, Prop } from 'vue-property-decorator';

import { setImageProfile } from '../../share/Util/Image/Image';

const DEFAULT_AVATAR = 'https://cdn.explicae.com.br/public/platform/avatar/avatar.jpg';

@Component({
  components: {}
})
export default class Avatar extends Vue {
  @Prop({ default: DEFAULT_AVATAR }) avatar!: string;
  @Prop() title!: string;

  get setAvatar() {
    return setImageProfile(this.avatar);
  }
}
